import { useDispatch, useSelector } from "react-redux";
import { UserActions } from "../redux/UserActions";
import React, { useState, useEffect } from "react";
import { API_URL } from "../redux/constants";
import PageTitle from "./General/PageTitle";
import { Link } from "react-router-dom";

export default function Priorities() {
  const userState = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [priorities, setPriorities] = useState([]);

  useEffect(() => {
    setPriorities(userState.priorities);
  }, [userState.priorities]);

  useEffect(() => {
    dispatch(UserActions.priorities({}));
  }, []);

  return (
    <div className="flex-col w-full bg-gray-50 p-6">
      <PageTitle>Priorities</PageTitle>
      <div className="flex flex-wrap gap-x-4 gap-y-4">
        {priorities.map((priority) => (
          <UserCard data={priority} />
        ))}
      </div>
    </div>
  );
}

function UserCard({ data }) {
  return (
    <>
      <div className="flex flex-col md:flex-row rounded-lg bg-white p-4 w-full gap-x-4 items-center ">
        <img
          className="flex h-20 w-20 rounded-full object-cover my-10"
          src={API_URL + "image/profile/" + String(data._id)}
        />
        <span className="flex flex-col h-full py-2 flex-grow">
          <label className="font-semibold text-xl ">
            {data.firstName + " " + data.lastName}
          </label>
          <hr className="border-0 mb-2" />
          <label className="font-semibold text-lg bg-green-100 rounded-md mr-auto px-2 ">
            {"+" + data.phone.code + " " + data.phone.number}
          </label>
          <hr className="border-0 mb-10" />
          <span className="flex flex-row gap-x-2 mr-auto">
            <Link
              className="my-2 mr-auto py-2 px-4 text-center text-white font-medium rounded bg-indigo-800"
              to={"/conversations/" + data._id}
            >
              Contact
            </Link>
            <Link
              className="my-2 mr-auto py-2 px-4 text-center text-white font-medium rounded bg-blue-600"
              to={"/users/" + data._id}
            >
              User Profile
            </Link>
          </span>
        </span>
        <span className="flex flex-col px-6">
          {data.priority.map((priority) => (
            <label className="text-red-600">{priority}</label>
          ))}
        </span>
      </div>
    </>
  );
}
